import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-operation-finished-modal',
  templateUrl: './operation-finished-modal.component.html',
  styleUrls: ['./operation-finished-modal.component.scss'],
})
export class OperationFinishedModalComponent implements OnInit {
  successful: boolean = false;

  title: string = 'Operación finalizada';
  content: string = 'La operación ha finalizado';
  submit: Subject<any>;

  constructor(private modalRef: BsModalRef) {
    this.submit = new Subject();
  }

  ngOnInit(): void {}

  close() {
    this.submit.next('closed');
    this.modalRef.hide();
  }
}
